import { createTheme } from '@mui/material/styles';

const fontStack =
  "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

/** Matches `src/App.css` --primary-color and --default-fonts */
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 426,
      md: 769,
      lg: 1025,
      xl: 1441,
    },
  },
  palette: {
    primary: {
      main: '#1841ff',
    },
  },
  typography: {
    fontFamily: fontStack,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: fontStack,
        },
      },
    },
  },
});

export default theme;
